import React, { useState, useEffect, useMemo, } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import i18n from 'i18next';

//MUI
import { Box, Divider, Stack, Button, Checkbox, } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import DownloadIcon from '@mui/icons-material/Download';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

//API
import { fnExcel, fnCallPopUp, fni18n } from "../../services/commonService";
import { API, PAGE } from "../../config";
import { getAPI, postAPI, putAPI, deleteAPI } from "../../services/commonService";
import AuthenticationService from "../auth/AuthenticationService";

// custom UI
import UTable from "../../components/mui/UTable";
import UDataGrid from "../../components/mui/UDataGrid";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UPagination from "../../components/mui/UPagination";
import GroupDetailPage from "./GroupDetailPage";
import GroupForm from "./GroupForm";
import GroupAuthForm from "../system/GroupAuthForm";
import UAuthButton from "../../components/mui/UAuthButton";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import USnackbar from "../../components/mui/USnackbar";
import UAuthFabAdd from "../../components/mui/UAuthFabAdd";
import USelectBox from "../../components/mui/USelectBox";
import { theme } from '../../assets/themes';
import UPopupForm from "../../components/mui/UPopupForm";

const useYn = [{cd:'Y', name:'Y'}, {cd:'N', name:'N'}, ];

const ROLE_TYPE = {
  '1': 'ADMIN',
  '2': 'BRANCH',
  '3': 'STORE',
};

const GroupPage = () => {
  const { t } = useTranslation();
  // const [userName, setUserName] = useState('');
  
  const userLoginId = AuthenticationService.getLoggedInUserID();
  const [ groupList, setGroupList ] = useState([]); //그룹 리스트
  const [ groupDetailInfo, setGroupDetailInfo ] = useState({  //그룹 상세 정보
      grpCd : "new",
      grpNm : "",
      grpDesc : "",
      useYn: 'Y',
      inAvailYn : "N",
      outAvailYn : "N",
      regUserId : userLoginId,
  }); 
  const [ rowSelected, setRowSelected  ] = useState({}); // row선택 시 담아두기
  const [ loading, setLoading ] = useState(false);
  const [ searchVal, setSearchVal ] = useState({  //검색 정보
    grpCd :  "",
    grpNm : "",
    useYn: 'Y',
  });

  const [ formAuthOpen, setFormAuthOpen ] = useState(false); // modify auth dialog
  const [ formOpen, setFormOpen ] = useState(false); // modify dialog
  const [ confirmPopupOpen, setConfirmPopupOpen ] = useState(false); // confirm dialog
  const [ errorPopupOpen, setErrorPopupOpen ] = useState(false); // error dialog
  const [ showError, setShowError ] = useState(false);
  const [ errorMsg, setErrorMsg ] = useState(""); // api error message
  const [ snackOpen, setSnackOpen ] = useState(false);
  const [ snackSeverity, ] = useState('success');
  const [ snackMessage, setSnackMessage ] = useState('');

  const location = useLocation();

  /**
   * 화면 로드 시
   */
  useEffect(() => {
    const getLoadData =  () => {
      handleSearch()
    };
    getLoadData();
  }, []);

  //검색 조건 setter
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchVal({
      ...searchVal,
      [name] : value
    })
  }

  // 입력 데이타 유효성 검사
  const errors = useMemo(() => {
    const errors = {};
    if ( !groupDetailInfo.grpNm ) {
      errors.grpNm = fni18n('필수 입력 항목입니다')//'그룹명은 필수 입력 항목입니다.'
    }
    if ( groupDetailInfo.grpNm && groupDetailInfo.grpNm.length > 50 ) {
      errors.grpNm = fni18n('최대 길이가 50입니다')//'그룹명은 최대 길이가 50입니다.'
    }
    if ( !groupDetailInfo.grpLevel ) {
      errors.grpLevel = fni18n('필수 입력 항목입니다')//'필수 입력 항목입니다.'
    }
    return errors;
  }, [groupDetailInfo])

  //검색 조건 변경시 setter
  const onSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchVal({
      ...searchVal,
      [name]: value,
    });
  }

  // 조회함수
  const handleSearch = async () => {
    setGroupList([]);
    let data = {
      grpCd : searchVal.grpCd.trim(),
      grpNm : searchVal.grpNm.trim(),
      useYn : searchVal.useYn.trim(),
    };
    try {
      setLoading(true);
      await getAPI(API.SYSTEM.GROUP, searchVal)
      .then((res) => {
        setGroupList(res.data.result);
      })
      .catch((err) => {
        console.log("Search Error! ", err);
      })
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }
  // 상세 정보 변경 시 setter
  const onDetailChange = (e) => {
    const { name, value } = e.target;
    setRowSelected({
        ...rowSelected,
        [name] : value,
    });
    setGroupDetailInfo({
        ...groupDetailInfo,
        [name] : value,
    });
  };
  // 상세 YN 변경 시 setter
  const onSwitchChange = (e) => {
    setGroupDetailInfo({
      ...groupDetailInfo,
      [e.target.name]: e.target.checked === true ? "Y" : "N",
    });
  };
  //DataGrid에서 row 선택 시 
  const onSelectedRow = (row, field) => {
    setRowSelected(row)
    setGroupDetailInfo(row)
    field === 'modify' ? handleFormOpen() : handlePopup()
  };
  // 저장함수
  const handleSave = () => {
    if ( Object.keys(errors).length > 0 ) {
      // handleErrorOpen()
      setShowError(true)
      return;
    }
    try {
      if (groupDetailInfo.grpCd === "new") { // 신규 등록
        postAPI(API.SYSTEM.GROUP, groupDetailInfo)
        .then((res) => {
          if (res.data.code === 200) {
            // handleCancel();
            handleSearch();
            // snack bar success open
            setSnackMessage(res.data.message);
            handleSnackOpen();
            handleFormClose()
          } else {
            // setErrorMsg(res.data.message || "Processing failed.")
            setErrorMsg(t("처리가 실패하였습니다"))
            handleErrorOpen()
          }
        })
        .catch((err) =>{
          console.log("메뉴그룹 등록 Error! ", err);
        });
      } else  { // 수정
        putAPI(API.SYSTEM.GROUP, groupDetailInfo)
        .then((res) => {
          if (res.data.code === 200) {
            //handleCancel();
            handleSearch();
            // snack bar success open
            setSnackMessage(res.data.message);
            handleSnackOpen();
            handleFormClose()
          } else {
            // setErrorMsg(res.data.message || "Processing failed.")
            setErrorMsg(t("처리가 실패하였습니다"))
            handleErrorOpen()
          }
        })
        .catch((err) =>{
          console.log("메뉴그룹 수정 Error! ", err);
        });
      }
    } catch (e) {
      console.log("수정 Error! ", e);
    } finally {
    }
  }
  // 삭제함수
  const handleDelete = () => {
    // if ( Object.keys(errors).length > 0 ) {
    //   return;
    // }
    if (groupDetailInfo.grpCd == '5001' || groupDetailInfo.grpCd == '5002' || groupDetailInfo.grpCd == '5003') {
      setErrorMsg(t("삭제할 수 없는 그룹입니다"));
      handleErrorOpen();
      handleConfirmClose();
      return;
    }
    
    try {
      deleteAPI(API.SYSTEM.GROUP, {grpCd : groupDetailInfo.grpCd})
      .then((res) => {
        if (res.data.code === 200) {
          // handleCancel();
          handleSearch();
          // snack bar success open
          setSnackMessage(res.data.message);
          handleSnackOpen();
          handleFormClose()
        } else {
          // setErrorMsg(res.data.message || "Processing failed.")
          setErrorMsg(t("처리가 실패하였습니다"))
          handleErrorOpen()
        }
      })
      .catch((err) =>{
        console.log("메뉴그룹 삭제 Error! ", err);
      });
    } catch (error) {
      console.log(error)
    } finally{
      handleConfirmClose()
    }
  }
  // 되돌리기 함수(초기화)
  const handleCancel = () => {
    setRowSelected({})
    setGroupDetailInfo({
      grpCd : "new",
      grpNm : "",
      grpDesc : "",
      useYn: "Y",
      inAvailYn : "N",
      outAvailYn : "N",
      regUserId : userLoginId,
    })
    setShowError(false)
  }
  // 메뉴 권한 팝업창 오픈
  const handlePopup = () => {
    // if (groupDetailInfo.grpCd) fnCallPopUp(PAGE.SYSTEM.MENUAUTH_POPUP + "/" + groupDetailInfo.grpCd, 1200, 550);
    setFormAuthOpen(true)
  }
  const handleFormAuthClose = () => {
    setFormAuthOpen(false)
  }

  //삭제 확인 팝업 
  const handleConfirmOpen = () => {
    // if ( Object.keys(errors).length > 0  || groupDetailInfo.useYn === 'N') {
    //   return;
    // }
    setConfirmPopupOpen(true);
  };
  const handleConfirmClose = () => {
    setConfirmPopupOpen(false);
  };

  //오류팝업 
  const handleErrorOpen = () => {
    setErrorPopupOpen(true);
  };
  const handleErrorClose = () => {
    setErrorMsg("")
    setErrorPopupOpen(false);
  };

  //성공 스낵바 
  const handleSnackOpen = () => {
    setSnackOpen(true);
  };
  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };

  //신규등록
  const handleAddNew = () => {
    handleCancel()
    handleFormOpen()
  }

  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };
  /**
   * main list column set
   */
  const columns = [
    /*
    {
      field: "id",
      headerName: "번호",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    */
    {
      field: "grpCd",
      headerName: "그룹번호",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "grpNm",
      headerName: "그룹명",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "grpLevel",
      headerName: "그룹유형",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        return ROLE_TYPE[params.value]? ROLE_TYPE[params.value]: 'N/A';
      }
    },
    {
      field: "grpDesc",
      headerName: "설명",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "useYn",
      headerName: "사용여부",
      width: 100,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      },
    },
    {
      field: "inAvailYn",
      headerName: "입금가능",
      width: 80,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      }
    },
    {
      field: "outAvailYn",
      headerName: "출금가능",
      width: 80,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params)=>{
        if (params.value == 'Y') {
          return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
        } else {
          return <Checkbox checked={false} disabled/>
        }
      }
    },
    {
      field: "regUserNm",
      headerName: "등록자",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
    field: "regDt",
        headerName: "등록일자",
        width: 150,
        headerAlign: "center",
        align: "center",
        /*valueFormatter: (params) => {
            if (params.value == null) {
                return "";
            }
            const valueFormatted = params.value.replace(
                    /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
                    "$1-$2-$3"
                );
            return `${valueFormatted}`;
        },*/
    },
    {
      field: 'modify',
      headerName: '설정',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) =>
      (
        <UButton
        variant="outlined"
        // onButtonClick={handleFormOpen}
        onButtonClick={()=>onSelectedRow(params.rows, 'modify')}
        menuFrom={location.pathname}
        >
        보기
        </UButton>
      ),
    },
    {
      field: 'modifyAuth',
      headerName: '권한',
      width: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
      (
        <UButton
        variant="outlined"
        // onButtonClick={handlePopup}
        onButtonClick={()=>onSelectedRow(params.rows, 'modifyAuth')}
        menuFrom={location.pathname}
        >
        보기
        </UButton>
      ),
    },
  ];
/**
   * main list grouping column set
   */
  const columnGroupingModel = [
    {
        groupId: ' ',
        children: [{ field: 'grpCd' },{ field: 'grpNm' },{ field: 'grpDesc' }],
        headerAlign: "center",
    },
    
    {
      groupId: fni18n('거래권한'),
      children: [{ field: 'outAvailYn' }, { field: 'inAvailYn' }],
      headerAlign: "center",
    },
    {
        groupId: '  ',
        children: [{ field: 'regUserNm' },{ field: 'regDt' },{ field: 'modify' },{ field: 'modifyAuth' }],
        headerAlign: "center",
    },
  ];
  return (
    <div className="main-container">
      <div className="header">
        <Grid container>
          <Grid item xs={10}>
            {/* 상단메뉴명 */}
            <UBreadCrumbs
              title={"시스템관리"}
              subtitle={"그룹관리"}
            />
          </Grid>
          <Grid item xs={2}>
            {/* 툴바 버튼 */}
            <Stack 
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-start"
			        spacing={0.5}
            >
              {/* <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton>
              <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton> */}
            </Stack>
          </Grid>
        </Grid>
      </div>
        {/* <Divider/>  */}
        
        {/* 조회조건 */}
        <Box className="contents">
          <TableContainer className="table-container" component={Paper} elevation={0}>
          <Table className="table" size="small">
              <TableBody>
              <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">{fni18n('그룹번호')}</TableCell>
                  <TableCell className="table-cell">
                    <UTextField
                    name="grpCd"
                    onChange={onSearchChange} 
                    /> 
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n('그룹명')}</TableCell>
                  <TableCell className="table-cell">
                    <UTextField
                    name="grpNm"
                    onChange={onSearchChange} 
                    /> 
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                  <TableCell className="table-cell">
                    <USelectBox
                      id="useYn"
                      name="useYn"
                      items={useYn}
                      onItemChange={handleChange}
                      defaultValue={searchVal.useYn}
                    />
                  </TableCell>
                  <TableCell className="table-cell"></TableCell>
                  <TableCell className="table-cell"></TableCell>
              </TableRow>
              </TableBody>
          </Table>
          </TableContainer>
          <div className="search">
              <UButton icon="Search" onButtonClick={handleSearch}>조회</UButton>
          </div>
          {/* <Divider/> */}

          {/* 조회 리스트 */}
          <div style={{  width: "100%", display: "grid" }}>
            <div>
              {/* <UDataGrid columns={columns} columnGroupingModel={columnGroupingModel} data={groupList} onSelectedRow={onSelectedRow} />  */}
              <UTable columns={columns} rows={groupList} rowPerPage={11}
              toolbarAdd={
                <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={handleAddNew}>추가</UAuthButton>
              }              
              />
            </div>
          </div>
        </Box> 

        {/* 상세 처리 버튼 리스트 >> 팝업으로 변경*/}
        {/* 조회 리스트 선택 상세 >> 팝업으로 변경*/}
        {/* <Box sx={{ p: 1 }}>
        <Grid container>
          <Grid item xs={8}>
          </Grid>
          <Grid item xs={4}>
          <Stack direction="row" spacing={2}>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Save"
                onButtonClick={handleSave}
                menuFrom={location.pathname}
              >
                저장
              </UAuthButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Delete"
                onButtonClick={handleConfirmOpen}
                menuFrom={location.pathname}
              >
                삭제
              </UAuthButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Cancel"
                onButtonClick={handleCancel}
                menuFrom={location.pathname}
              >
                취소
              </UAuthButton>
            </FormControl>
            <FormControl sx={{ width: btnSize_wid }}>
              <UAuthButton
                icon="Launch"
                onButtonClick={handlePopup}
                menuFrom={location.pathname}
                >
                권한
              </UAuthButton>
            </FormControl>
            </Stack>
          </Grid>
        </Grid>
        </Box>

        <GroupDetailPage 
        data={groupDetailInfo} 
        onChange={onDetailChange} 
        onSwitchChange={onSwitchChange}
        errors={errors}
        showError={showError}
        /> */}
        
        {/* 삭제 확인 팝업  */}
        <UConfirmDialog
        message={'[' + groupDetailInfo.grpCd + ' ' + groupDetailInfo.grpNm + '] ' + i18n.t('그룹을 삭제하시겠습니까?')}//
        open={confirmPopupOpen}
        onClose={handleConfirmClose}
        onClickOk={handleDelete}
        />

        {/* 오류 확인 팝업  */}
        <UAlertDialog
        alerts={errors}
        message={errorMsg}
        open={errorPopupOpen}
        onClose={handleErrorClose}
        />

        {/* 성공 스낵바  */}
        {/* <USnackbar
        open={snackOpen}
        onClose={handleSnackClose}
        severity={snackSeverity}
        message={snackMessage}
        /> */}

        {/* 폼 팝업  */}
        {/* <GroupForm
        title={fni18n("그룹관리")}
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleSave}
        onDelete={handleConfirmOpen}
        detailInfo={groupDetailInfo} 
        onDetailChange={onDetailChange} 
        onSwitchChange={onSwitchChange}
        errors={errors}
        showError={showError}
        /> */}
        <UPopupForm
          open={formOpen}
          onClose={handleFormClose}
          onSave={handleSave}
          onSecondBt={handleConfirmOpen}
          title="그룹 설정"
          SecondBtName={'삭제'}
          type={groupDetailInfo.grpCd==="new"?"2":"3"}
          content={
            <GroupDetailPage 
            data={groupDetailInfo} 
            onChange={onDetailChange} 
            onSwitchChange={onSwitchChange}
            errors={errors}
            showError={showError}
            />
          }
          /> 

          {/* 권한관리 팝업  */}
          {/* <GroupAuthForm
            title={fni18n("권한관리")}
            open={formAuthOpen}
            onClose={handleFormAuthClose}
            grpCd={groupDetailInfo.grpCd}
          /> */}
          <UPopupForm
              open={formAuthOpen}
              content={<GroupAuthForm grpCd={groupDetailInfo.grpCd} open={formAuthOpen} onClose={handleFormAuthClose} title={fni18n("권한관리")}/>}
              type={"1"}
              maxWidth={"xl"}
          />
        {/* 추가버튼 */}
        {/* <UAuthFabAdd menuFrom={location.pathname} onClick={handleAddNew} /> */}
    </div>

  );
}
export default GroupPage;